import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { locale as enLang } from './configs/i18n/en';
import { locale as frLang } from './configs/i18n/fr';
import { AuthService } from './modules/auth/shared/auth.service';
import { TranslationService } from './modules/core/services/translation.service';
import { LocalStoreService } from './shared/services/local-store.service';
import { NotificationDeviceTokensService } from './shared/services/notification-device-tokens.service';
import { NotificationService } from './shared/services/notification.service';
import { Lang, MetaDataService } from './shared/services/meta-data.service';
import { environment } from 'src/environments/environment';
import { SiteAdminService } from './services/site-admin.service';

// import { locale as chLang } from './core/_config/i18n/ch';
// import { locale as esLang } from './core/_config/i18n/es';
// import { locale as jpLang } from './core/_config/i18n/jp';
// import { locale as deLang } from './core/_config/i18n/de';
// import { locale as frLang } from './core/_config/i18n/fr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'ssrui';
  loader = true;
  constructor(
    private router: Router,
    private localStorageService: LocalStoreService,
    private siteAdminService: SiteAdminService,
    private authService: AuthService,
    private translationService: TranslationService,
    private notificationService: NotificationService,
    private primengConfig: PrimeNGConfig,
    private notificationDeviceTokensService: NotificationDeviceTokensService,
    private metaDataService: MetaDataService,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: Document
  ) {
    // register translations
    this.translationService.loadTranslations(enLang);
    this.translationService.loadTranslations(frLang);
    this.requestPermissionForNotification();
  }

  ngOnInit(): void {
    if (environment.maintenance && !this.siteAdminService.getIsSiteAdmin()) {
      this.router.navigate(['/maintenance']);
    }
    this.authService.checkTokenExpiration();
    // enable/disable loader
    this.primengConfig.ripple = true;

    this.loader = true;
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo(0, 0);
          // to display back the body content
          setTimeout(() => {
            this.loader = false;
          }, 1000);
          // Handle router change event here
          const url = `${window.location.protocol}//${window.location.host}${event.url}`;
          this.metaDataService.setCanonicalUrl(url);
          this.metaDataService.setOpenGraph(
            'HomePage_Seo.description_content',
            '/assets/media/images/racebet365.png',
            url
          );
        }
      }
    });
    this.broadcastForNotificationServiceWorker();
    this.translationService.onLangChange.subscribe((value) => {
      this.document.documentElement.lang = Lang[value.lang];
    });
  }

  broadcastForNotificationServiceWorker() {
    if (isPlatformBrowser(this.platformId)) {
      const broadcast = new BroadcastChannel('notification-channel');

      this.translationService.onLangChange.subscribe((language) => {
        broadcast.postMessage({
          type: 'UPDATE_LANGUAGE',
          value: language.lang,
        });
      });
    }
  }

  requestPermissionForNotification() {
    const user = this.localStorageService.getItem('user');
    const userId = user?.user?.uid || null;

    this.notificationService.requestPermission(
      (token: string) => {
        if (!token) return;

        this.notificationService.receiveMessage();

        const notificationDeviceToken = this.localStorageService.getItem(
          'notificationDeviceToken'
        );
        if (notificationDeviceToken) return;
        this.notificationDeviceTokensService.upsertDevice(token, {
          token,
          userId,
        });
        this.localStorageService.setItem('notificationDeviceToken', token);
      },
      (error) => {
        console.error('Notification request permission error: ', error);
      }
    );

    // sets uid on auth change
    combineLatest([this.authService.authStatus]).subscribe(([user]) => {
      const deviceTokenData: any = {};
      deviceTokenData.userId = user?.uid || null;

      const notificationDeviceToken = this.localStorageService.getItem(
        'notificationDeviceToken'
      );
      if (notificationDeviceToken && Object.keys(deviceTokenData).length > 0) {
        this.notificationDeviceTokensService.upsertDevice(
          notificationDeviceToken,
          deviceTokenData
        );
      }
    });
  }
}
